import { JtechAxios } from 'src/plugins/axios'

export default {
  saveTechnicalLaboratory: async (data) => {
    return JtechAxios.request().post('/technicalAssessmentResiduesLaboraty', data, {
      headers: {
        'Content-Type': 'application/json;'
      }
    })
  },
  updateTechnicalLaboratory: async (data, id) => {
    return JtechAxios.request().put(`/technicalAssessmentResiduesLaboraty/${id}`, data, {
      headers: {
        'Content-Type': 'application/json;'
      }
    })
  },
  findTechnicalLaboratory: async (param) => {
    return JtechAxios.request().get(`technicalAssessmentResiduesLaboraty/${param}`)
  },
  getPageDetailData: async (id) => {
    return JtechAxios.request().get(`technicalAssessmentsResiduesComercial/data-detail/${id}`)
  },
  technicalAssessmentResidues: async (id) => {
    return JtechAxios.request().get(`technicalAssessmentResidues/${id}`)
  }
}
